import { Check } from 'lucide-react';
import { cn } from '@/lib/utils';

const FLOWS = {
  /** The three purchase steps: 0 Katalog · 1 Detail · 2 Bayar. */
  regular: ['Katalog', 'Detail', 'Bayar'],
  /** Free-of-charge flow: 0 Katalog FOC · 1 Dokumen · 2 Detail · 3 Bayar. */
  foc: ['Katalog FOC', 'Dokumen', 'Detail', 'Bayar'],
} as const;

export type StepFlow = keyof typeof FLOWS;

/**
 * `current` is the index into the flow's steps. The shared Details / Checkout
 * pages sit one step later in the FOC flow (after Dokumen).
 */
export function StepIndicator({
  current,
  flow = 'regular',
}: {
  current: number;
  flow?: StepFlow;
}) {
  const steps = FLOWS[flow];
  return (
    <nav className="flex items-center gap-1.5" aria-label="Langkah pembelian">
      {steps.map((label, i) => {
        const done = i < current;
        const active = i === current;
        return (
          <div key={label} className="flex items-center gap-1.5">
            <span
              className={cn(
                'flex h-6 w-6 items-center justify-center rounded-full text-xs font-bold tnum',
                done
                  ? 'bg-success text-white'
                  : active
                    ? 'bg-primary text-primary-foreground'
                    : 'bg-secondary text-ink-400',
              )}
              aria-current={active ? 'step' : undefined}
            >
              {done ? <Check className="h-3.5 w-3.5" /> : i + 1}
            </span>
            <span
              className={cn(
                'hidden text-sm font-medium sm:inline',
                active ? 'text-ink-900' : 'text-ink-400',
              )}
            >
              {label}
            </span>
            {i < steps.length - 1 && <span className="mx-0.5 h-px w-5 bg-border sm:w-6" />}
          </div>
        );
      })}
    </nav>
  );
}
